import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../store/selector";
import {StyledAdmissionAcceptRejectNote} from "./index.styles";
import {Col, Divider, Row, Spin} from "antd";
import {StyledButton} from "../AdmissionWithoutRanking/index.styles";
import {FifthStep} from "../../../components";
import {IconAccept, IconReject} from "../../../assets";
import {fetchExecutorEgovApplication, fetchGetInfoAction} from "../../../store/pages/admission/actions";
import {decodeBase64} from "../../../utils/decodeBase64";
import {encodeBase64} from "../../../utils/encodeBase64";

export const AdmissionAcceptRejectNote = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let {id} = useParams();
  const { t } = useTranslation(['executorAdmissionSteps', 'admissionView']);

  id = decodeBase64(id);

  const redirect = searchParams.get("redirect")

  const {profile: {userProfile: profileData}, admission: {getInfo, egovExecutor}} = useSelector(selectStore)

  const [type, setType] = useState(undefined as any)

  const setExecutorEgovApplication = () => {

    //@ts-ignore
    dispatch(fetchExecutorEgovApplication(id))
  }

  useEffect(() => {
    if (egovExecutor.success) {
      if (type === 'accept') {
        navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=accept`, {replace: true})
      } else if (type === 'reject') {
        navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=reject`, {replace: true})
      }
    }
  }, [egovExecutor])

  useEffect(() => {
    // user_id
    //@ts-ignore
    dispatch(fetchGetInfoAction({ education_order_id: id }))
  }, [])

  const handleRedirectToList = () => {
    window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}${redirect ? redirect : "/"}`)
  }

  return(
    <Row justify='center'>
      <Col span={20}>
        <Row>
          <Col span={24} style={{paddingTop: 32, paddingBottom: 32}}>
            <Spin spinning={profileData.loading}>
              <StyledAdmissionAcceptRejectNote>
                <Row style={{marginTop: 16}} align="middle" justify='space-between'>
                  <h1>{t('executorAdmissionSteps:admissionForm.application')} № {id}</h1>
                  <Row>
                    <StyledButton danger icon={<IconReject/>} size='large'
                                  onClick={() => {
                                    setType('reject')

                                    if (getInfo.data && getInfo.data.educationOrder.source === '1') {
                                      setExecutorEgovApplication()
                                    }

                                    // if (process.env.REACT_APP_ENV !== 'local') {
                                    //   window.parent.parentFunc();
                                    // }

                                    if (getInfo.data && getInfo.data.educationOrder.source !== '1') (
                                      navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=reject`, {replace: true})
                                    )
                                  }}
                                  style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '16px' }}>
                      {t('executorAdmissionSteps:admissionForm.reject')}
                    </StyledButton>
                    <StyledButton  icon={<IconAccept/>} size='large'
                                   onClick={() => {
                                     setType('accept')

                                     if (getInfo.data && getInfo.data.educationOrder.source === '1') {
                                       setExecutorEgovApplication()
                                     }

                                     // if (process.env.REACT_APP_ENV !== 'local') {
                                     //   window.parent.parentFunc();
                                     // }

                                     if (getInfo.data && getInfo.data.educationOrder.source !== '1') (
                                       navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=accept`, {replace: true})
                                     )
                                   }}
                                   style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      {t('executorAdmissionSteps:admissionForm.accept')}
                    </StyledButton>
                  </Row>
                </Row>
                <Divider style={{marginTop: 32, marginBottom: 32}} />
                {getInfo.data ?
                  (<>
                    <FifthStep isNeedTitle={false} educationOrder={getInfo.data}/>
                    <Row justify='center' style={{ paddingTop: 8, paddingBottom: 16 }}>
                      <StyledButton size='large' onClick={() => handleRedirectToList()}>
                        {t('admissionView:stepsButton.backToList')}
                      </StyledButton>
                      <StyledButton danger icon={<IconReject/>} size='large'
                                    onClick={() => {
                                      setType('reject')

                                      if (getInfo.data && getInfo.data.educationOrder.source === '1') {
                                        setExecutorEgovApplication()
                                      }

                                      // if (process.env.REACT_APP_ENV !== 'local') {
                                      //   window.parent.parentFunc();
                                      // }

                                      if (getInfo.data && getInfo.data.educationOrder.source !== '1') (
                                        navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=reject`, {replace: true})
                                      )
                                    }}
                                    style={{
                                      display: 'flex', flexDirection: 'row-reverse', marginRight: '16px',
                                      marginLeft: '16px'
                                    }}>
                        {t('executorAdmissionSteps:admissionForm.reject')}
                      </StyledButton>
                      <StyledButton icon={<IconAccept/>} size='large'
                                    onClick={() => {
                                      setType('accept')

                                      if (getInfo.data && getInfo.data.educationOrder.source === '1') {
                                        setExecutorEgovApplication()
                                      }

                                      // if (process.env.REACT_APP_ENV !== 'local') {
                                      //   window.parent.parentFunc();
                                      // }

                                      if (getInfo.data && getInfo.data.educationOrder.source !== '1') (
                                        navigate(`/entrant-admission-accept-reject/${encodeBase64(id)}/note?type=accept`, {replace: true})
                                      )
                                    }}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row-reverse',
                                    }}>
                        {t('executorAdmissionSteps:admissionForm.accept')}
                      </StyledButton>
                    </Row>
                  </>)
                  : 'Loading...'}
              </StyledAdmissionAcceptRejectNote>
            </Spin>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}